import http from './http';
import { Company, CompanyListResponse, CompanyFilter } from '@/types';

export const companyApi = {
  getGuestList: (params: CompanyFilter) =>
    http.get<CompanyListResponse>('/companies', { params }).then((r) => r.data),

  getList: (params: CompanyFilter) =>
    http.get<CompanyListResponse>('/companies', { params }).then((r) => r.data),

  getById: (id: string) =>
    http.get<{ data: Company }>(`/companies/${id}`).then((r) => r.data.data),

  create: (data: Partial<Company>) =>
    http.post<Company>('/companies', data).then((r) => r.data),

  update: (id: string, data: Partial<Company>) =>
    http.patch<Company>(`/companies/${id}`, data).then((r) => r.data),
};
